<div class="d-flex flex-column h-100 placeholder-glow">

    <!-- page header -->
    <div class="d-flex align-items-center mb-1">
        <h3 class="m-0 placeholder" style="padding-right: 2rem">
            <span class="placeholder" style="min-height: 1.5rem;width: 15rem;"></span>
        </h3>
        <div class="ms-auto">
            <div class="d-inline-flex gap-1">
                <button class="btn btn-primary btn-sm disabled placeholder" style="width: 4rem;"></button>
                <button class="btn btn-success btn-sm disabled placeholder" style="width: 4rem;"></button>
                <button class="btn btn-warning btn-sm disabled placeholder" style="width: 4rem;"></button>
                <button class="btn btn-danger btn-sm disabled placeholder" style="width: 4rem;"></button>
                <button class="btn btn-secondary btn-sm disabled placeholder" style="width: 4rem;"></button>
            </div>
        </div>
    </div>

    <div class="np-form-table mb-1" *ngIf="filterRowCnt > 0">
        <div class="row" *ngFor="let i of counter(filterRowCnt)">
            <div class="td col-12 col-md-6 col-lg-6">
                <div class="cell-head"><label><span class="my-1 placeholder col-12"
                            style="width: 4rem;min-height: 1rem;"></span></label></div>
                <div class="cell-text">
                    <span class="my-1 placeholder col-12" style="min-height: 1rem;"></span>
                </div>
            </div>
            <div class="td col-12 col-md-6 col-lg-6">
                <div class="cell-head"><label><span class="my-1 placeholder col-12"
                            style="width: 4rem;min-height: 1rem;"></span></label></div>
                <div class="cell-text">
                    <span class="my-1 placeholder col-12" style="min-height: 1rem;"></span>
                </div>
            </div>
        </div>
    </div>
    
    <div class="d-inline-flex gap-1 my-1">
        <button class="btn btn-primary btn-sm disabled placeholder" style="width: 4rem;"></button>
        <button class="btn btn-success btn-sm disabled placeholder" style="width: 4rem;"></button>
        <button class="btn btn-warning btn-sm disabled placeholder" style="width: 4rem;"></button>
        <button class="btn btn-danger btn-sm disabled placeholder" style="width: 4rem;"></button>
        <button class="btn btn-secondary btn-sm disabled placeholder" style="width: 4rem;"></button>
    </div>

    <div class="h-100 rounded-1 d-flex flex-column" style="min-height: 1%;">
        <div class="d-flex flex-column h-100" style="min-height: 100px;background-color: #eeeeee;">
            <div class="p-3 my-1">
                <span class="my-2 placeholder col-12" style="min-height: 1rem;"></span>
                <span class="my-2 placeholder col-12" style="min-height: 1rem;"></span>
                <span class="my-2 placeholder col-12" style="min-height: 1rem;"></span>
                <span class="my-2 placeholder col-12" style="min-height: 1rem;"></span>
                <span class="my-2 placeholder col-12" style="min-height: 1rem;"></span>
                <span class="my-2 placeholder col-12" style="min-height: 1rem;"></span>
                <span class="my-2 placeholder col-12" style="min-height: 1rem;"></span>
                <span class="my-2 placeholder col-12" style="min-height: 1rem;"></span>
            </div>
        </div>
        <div class="my-1">
            <span class="my-2 placeholder col-12" style="min-height: 1rem;"></span>
        </div>
    </div>

</div>